import { render, staticRenderFns } from "./restricter.vue?vue&type=template&id=2c136bf7&"
import script from "./restricter.vue?vue&type=script&lang=js&"
export * from "./restricter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports